import React from 'react';
import PropTypes from 'prop-types';

export default function IconActiveUser({ className }) {
  return (
    <svg className={className} fill="none" height="17" viewBox="0 0 17 17" width="17" xmlns="http://www.w3.org/2000/svg">
      <path d="M3 4C3 1.79086 4.79086 0 7 0C9.20914 0 11 1.79086 11 4C11 6.20914 9.20914 8 7 8C4.79086 8 3 6.20914 3 4ZM0 11C0 9.88687 0.903151 9 2.00873 9L8.25716 9C7.47182 9.95094 7 11.1704 7 12.5C7 13.8031 7.45316 15.0003 8.21047 15.9427C7.8155 15.9811 7.41085 16 7 16C5.14526 16 3.41697 15.614 2.13499 14.7966C0.83281 13.9663 0 12.6912 0 11ZM17 12.5C17 14.9853 14.9853 17 12.5 17C10.0147 17 8 14.9853 8 12.5C8 10.0147 10.0147 8 12.5 8C14.9853 8 17 10.0147 17 12.5ZM14.8536 10.6464C14.6583 10.4512 14.3417 10.4512 14.1464 10.6464L11.5 13.2929L10.8536 12.6464C10.6583 12.4512 10.3417 12.4512 10.1464 12.6464C9.95118 12.8417 9.95118 13.1583 10.1464 13.3536L11.1464 14.3536C11.3417 14.5488 11.6583 14.5488 11.8536 14.3536L14.8536 11.3536C15.0488 11.1583 15.0488 10.8417 14.8536 10.6464Z" fill="currentColor"/>
    </svg>

  );
}

IconActiveUser.propTypes = {
  className: PropTypes.string,
};
